import React, { FunctionComponent } from 'react';

const Scheduler: FunctionComponent = () => <div>This will be the page for displaying the scheduler!</div>;

export default Scheduler;
